import { color, extendTheme } from "@chakra-ui/react";

const theme = extendTheme({
  styles: {
    global: {
      body: {
        bgColor: "#1D1D1D",
        bgImage: "url('/bg.png')",
        bgRepeat: "repeat-y",
        bgSize: "100% auto",
        color: "white",
        fontFamily: "Blinker",
      },
    },
  },
});

export default theme;
